export default {
  loadCategories (state, value) {
    state.categories = value
  },
  loadAllowedCategories (state, value) {
    state.allowedCategoriesForScheduled = value
  },
  loadPayments (state, value) {
    state.payments = value
  },
  resetCategorie (state) {
    state.categories = []
  }
}



// WEBPACK FOOTER //
// ./src/store/detalheCadastro/mutations.js